
import TableMixins from './TableMixins'
import { Component, Mixins, Prop } from 'vue-property-decorator'

@Component
export default class TableImage extends Mixins(TableMixins) {
  @Prop({ default: 91 })
  declare width: number
}
